import { IS_STAGING } from "./api";

/**
 * Every outbound and self-referential URL, in one place so a rebrand is a single edit —
 * these were previously hardcoded across Support.tsx, SignUp.tsx and constant/index.tsx.
 *
 * Mirrors deex-new-pwa/src/constants/links.ts.
 */

// Legal/informational pages are only published on production, so they don't branch by env
// (that matches the behaviour before the usedeex.com rebrand).
export const MARKETING_URL = "https://www.usedeex.com";

export const PRIVACY_URL = `${MARKETING_URL}/privacy`;
export const TERMS_URL = `${MARKETING_URL}/terms`;
export const ABOUT_URL = `${MARKETING_URL}/about`;
export const CONTACT_URL = `${ABOUT_URL}#contact`;

export const SUPPORT_EMAIL = "support@usedeex.com";

/**
 * This app's own public origin. Used to build the shareable business and payment page
 * links merchants hand to their customers.
 *
 * Staging normalised to `business.staging.` — the old domain used `staging.business.`,
 * which was inconsistent with every other app. See ALLOWLIST-ORIGINS.md; DNS must be
 * created in this shape or the links 404.
 */
export const MERCHANT_BASE_URL = IS_STAGING
  ? "https://business.staging.usedeex.com"
  : "https://business.usedeex.com";
